import React, { useState } from "react";
import styled from "styled-components";
import { Button, ButtonGroup, Dialog, Icon, TextArea } from "@blueprintjs/core";
import { Tooltip } from "@mantine/core";

import { RuleFromYaml } from "../../types";

type DialogProps = {
  rule: RuleFromYaml;
  isOpen: boolean;
  onSave: (id: string, message: string) => void;
  closeDialog: () => void;
};

type Props = {
  rule: RuleFromYaml;
  onUpdateRuleOverride: (id: string, message: string) => void;
};

const StyledDialog = styled(Dialog)`
  padding: 24px;
  font-size: var(--global-font-size-s);
`;

const Header = styled.div`
  font-size: var(--global-font-size-l);
  text-align: center;
  margin-bottom: 20px;
`;

const HoverButton = styled(Button)`
  visibility: hidden;
  tr:hover & {
    visibility: visible;
  }
`;

const EditRuleDialog: React.FC<DialogProps> = ({
  rule,
  isOpen,
  onSave,
  closeDialog,
}) => {
  const [message, setMessage] = useState(rule.message);
  return (
    <StyledDialog isOpen={isOpen}>
      <Header>{rule.id}</Header>
      Message
      <TextArea
        fill
        value={message}
        style={{ height: "100px" }}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
          setMessage(event.target.value);
        }}
      />
      <ButtonGroup
        style={{ marginTop: "var(--global-spacing-xl)", marginLeft: "auto" }}
      >
        <Button
          onClick={() => {
            onSave(rule.id, message);
            closeDialog();
          }}
          disabled={message === rule.message}
          intent="primary"
        >
          Save
        </Button>
        <Button onClick={closeDialog} intent="primary" outlined>
          Cancel
        </Button>
      </ButtonGroup>
    </StyledDialog>
  );
};

export const EditRuleCell: React.FC<Props> = ({
  rule,
  onUpdateRuleOverride,
}) => {
  const [showEditDialog, setShowEditDialog] = useState(false);
  return (
    <>
      <Tooltip label="Click to edit rule message" withArrow withinPortal>
        <div>
          <HoverButton minimal onClick={() => setShowEditDialog(true)}>
            <Icon icon={"edit"} />
          </HoverButton>
        </div>
      </Tooltip>
      <EditRuleDialog
        rule={rule}
        isOpen={showEditDialog}
        onSave={onUpdateRuleOverride}
        closeDialog={() => setShowEditDialog(false)}
      />
    </>
  );
};
